import { useParams } from "react-router";
import { Col, Row } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import Loader from "../loader/loader";
import PieChart from "../charts/pieChart";
import { CustomCard } from "../common-styling";
import CardDataContainer from "../leads/card-container";
import { showError } from "../../services/toast-service";
import AdvancedFilters from "../table-filter/advanced-filter";
import { getEuroCurrencyData } from "../../services/common-service";
import { campaignReviewFilterConfig } from "../funnels-table/filter-config";
import { getFunnelBasedCampaignsReview } from "../../services/api-declaration";
import { useTranslation } from "react-i18next";

const CampaignsReview = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [campaignsInfo, setCampaignsInfo] = useState([]);

  const getCampaignsReview = async (_funnelId) => {
    if (!_funnelId) return;
    setIsLoading(true);
    try {
      const params = {};
      for (const [key, value] of searchParams.entries()) {
        params[key] = value;
      }
      const response = await getFunnelBasedCampaignsReview(_funnelId, params);
      setCampaignsInfo(response.data.data);
    } catch (error) {
      const msg = "Error in getting campaigns review!";
      showError(error.response?.data?.message || msg);
      console.log(msg, error);
    } finally {
      setIsLoading(false);
    }
  };

  const cb = useCallback(
    (_funnelId) => getCampaignsReview(_funnelId),
    // eslint-disable-next-line
    [searchParams]
  );
  useEffect(() => {
    cb(id);
  }, [cb, id]);

  return (
    <div className="my-4">
      <div style={{ zIndex: "1020 !important" }}>
        <AdvancedFilters
          hideSearchFilter
          clearPaginationParam
          components={campaignReviewFilterConfig}
        />
      </div>
      <CustomCard className="p-3 mt-2 mb-3">
        {isLoading ? (
          <Loader calcHeight={300} />
        ) : campaignsInfo.length ? (
          <Row className="g-3">
            {campaignsInfo.map((info) => (
              <Col xs={12} md={4} key={info._id}>
                <CustomCard className="p-2 h-100">
                  <div className="h-100 d-flex flex-column">
                    <CardDataContainer
                      collection={[
                        { label: t("common.name"), value: info.campaignName },
                        { label: "ID", value: info._id },
                        { label: "Leads", value: info.totalLeadsCount },
                        {
                          label: t("campaignsReview.spend"),
                          value: getEuroCurrencyData(info.spend)
                        }
                      ]}
                    />
                    <div className="flex-fill">
                      <PieChart
                        chartWidth={275}
                        chartHeight={275}
                        series={[
                          info.positiveCount,
                          info.negativeCount,
                          info.neutralCount,
                          info.noStageCount
                        ]}
                        labels={[
                          `${t("campaignsReview.positive")}: ${
                            info.positiveCount
                          }`,
                          `${t("campaignsReview.negative")}: ${
                            info.negativeCount
                          }`,
                          `${t("campaignsReview.neutral")}: ${
                            info.neutralCount
                          }`,
                          `${t("campaignsReview.noStage")}: ${
                            info.noStageCount
                          }`
                        ]}
                        colors={["#66BE0F", "#EC4D4E", "#616161", "#2196f3"]}
                      />
                    </div>
                  </div>
                </CustomCard>
              </Col>
            ))}
          </Row>
        ) : (
          <CustomCard className="p-2">
            <h6 className="mb-0 fw-bold p-5 align-self-center">
              {t("noData")}
            </h6>
          </CustomCard>
        )}
      </CustomCard>
    </div>
  );
};
export default CampaignsReview;
